export const LICENSE_OUTCOME = {
  PREMIUM_OK: 'premium_ok',
  LICENSE_INVALID: 'license_invalid',
  NO_LICENSE: 'no_license',
};

export const CREATION_MESSAGES = {
  [LICENSE_OUTCOME.PREMIUM_OK]:
    'El camionero fue dado de alta correctamente. Ya puedes comenzar a usar HUMBER',
  [LICENSE_OUTCOME.LICENSE_INVALID]:
    'Error al validar el registro de conducir. Para poder comenzar a usar HUMBER deberemos primero validar el registro. Dentro de las 24 horas nos estaremos contactando con usted',
  [LICENSE_OUTCOME.NO_LICENSE]:
    'El registro de conducir no fue adjuntado. Para poder comenzar a usar HUMBER deberemos primero validar el registro. Dentro de las 24 horas nos estaremos contactando con usted',
};

export const EDIT_MESSAGES = {
  [LICENSE_OUTCOME.PREMIUM_OK]:
    'El camionero se guardó correctamente. Ya podés seguir usando Humber',
  [LICENSE_OUTCOME.LICENSE_INVALID]:
    'Error al validar el registro de conducir. Para poder seguir usando Humber deberemos primero validar el registro. Dentro de las 24 horas nos estaremos contactando con usted',
};
